module.exports = __webpack_public_path__ + "img/icon-Stretch-cc.a1d14e1d.png";